import type { SVGProps } from "react";
// generated from DownloadFile.svg — do not edit manually
// prettier-ignore
export default function DownloadFile(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 14 2 H 4 V 22 H 20 V 8 M 14 2 L 20 8 M 14 2 V 8 H 20 M 15 15 L 12 18 M 12 18 L 9 15 M 12 18 V 12" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
